export const root = "r96vifk";
export const filterContent = "fnj0eq5";
export const dateSelector = "d1txtqcz";
export const checkbox = "c10lkr5y";

// Active is distinct from checked because the checkbox will
// be checked immediately after interaction, though the query
// may not have been executed in the background yet, and as
// such is not informing "active" correctly. This way we get
// immediate feedback from the checkbox animation, followed by
// a bolded text when the filter has actually been applied.
export const filterActive = "frr68h3";
export const filterCount = "ftbif8m";
export const inactiveFilterCount = "i1lxdn6y";
export const tabsWrapper = "t1jjv4lu";
export const filterControls = "fvjtfqc";
export const reset = "rot3ad5";
export const communityIcon = "c8zd7ag";
export const encoreIcon = "edkqnf8";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");